module.exports = __webpack_public_path__ + "static/vraja-palini-e736e966b574c7eb00282d6367c5fe69.jpg";